import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss']
})

export class DropdownComponent {

  @Input() xPosition: string;
  @Input() top: string;

  public isMenuShown: boolean;

  onTriggerClick(e: Event) {
    this.isMenuShown ? this.hideMenu() : this.showMenu();
  }

  showMenu() {
    this.isMenuShown = true;
  }

  hideMenu() {
    this.isMenuShown = false;
  }
}
